// extracted by mini-css-extract-plugin
module.exports = {"container":"audio-detail-toolbar_container__7Y8dH","upload-container":"audio-detail-toolbar_upload-container__1UM5F","size-container":"audio-detail-toolbar_size-container__38oN4"};